const formatCepMask = cepNumber => {
  const cepPattern = /^(\d{0,5})(\d{0,3})$/;
  const formattedCep = cepNumber.replace(cepPattern, (match, p1, p2) => {
    return p1 + (p2 ? `-${p2}` : '');
  });
  return formattedCep;
};

export default formatCepMask;
